module.exports = __webpack_public_path__ + "static/media/400018_02.9a845483.png";